module.exports = __webpack_public_path__ + "assets/e238384aff7dcd0da6d4051b38a4d3a5.svg";